import type { TFunction } from "react-i18next"

import {
  CustomFormsSchemaFieldType,
  EmployerOfRecord,
  EmployerOfRecordEntityTypeEnum,
  GlobalPayrollEorEntityTypeEnum,
} from "@oysterhr/schema"

export const entityTypeMappedToTranslationKey: Record<EmployerOfRecordEntityTypeEnum, string> = {
  [EmployerOfRecordEntityTypeEnum.OwnEntity]: "OwnEntity",
  [EmployerOfRecordEntityTypeEnum.Subcontractor]: "SubContractor",
  [EmployerOfRecordEntityTypeEnum.Unknown]: "NotKnown",
}

export const generalTabFields = (
  t: TFunction<"staff_interface/VendorsPage", string>,
  data?: EmployerOfRecord,
) => {
  const entityType = data?.entityType?.toLocaleLowerCase()

  return [
    {
      label: "name",
      value: data?.name,
      editModeType: CustomFormsSchemaFieldType.Text,
    },
    {
      label: "country", // translation key
      type: "country",
      editModeType: CustomFormsSchemaFieldType.Country,
      value: data?.employerOfRecordCountry?.alpha2,
    },
    {
      label: "position",
      value: data?.position,
      editModeType: "choiceInCountry",
      hideInReadMode: data?.position !== 1,
    },
    {
      label: "direct",
      type: "vendorType",
      editModeType: CustomFormsSchemaFieldType.Radio,
      options: [
        {
          value: "employer_of_record",
          label: t("detailsPage.direct.options.employerOfRecord"),
        },
        {
          value: "payroll_partner",
          label: t("detailsPage.direct.options.payrollPartner"),
        },
      ],
      value:
        entityType === GlobalPayrollEorEntityTypeEnum.Direct.toLocaleLowerCase()
          ? "payroll_partner"
          : entityType === GlobalPayrollEorEntityTypeEnum.Indirect.toLocaleLowerCase()
            ? "employer_of_record"
            : "payroll_entity",
    },
    {
      label: "entityType",
      editModeType: CustomFormsSchemaFieldType.Dropdown,
      type: "entityType",
      options: Object.values(EmployerOfRecordEntityTypeEnum).map(value => ({
        value: value,
        label: t(`detailsPage.entityType.options.${entityTypeMappedToTranslationKey[value]}`),
      })),
      value: data?.details?.entityType,
    },
    {
      label: "legalName",
      editModeType: CustomFormsSchemaFieldType.Text,
      value: data?.details?.legalName,
    },
    {
      label: "legalAddress",
      editModeType: CustomFormsSchemaFieldType.Text,
      value: data?.details?.legalAddress,
    },
    {
      label: "companyContactEmails",
      editModeType: "email",
      value: data?.details?.companyContactEmails?.map((email: string) => {
        return {
          email,
        }
      }),
      type: "email",
    },
  ]
}
